import { render } from "./ClassicBreadCrumb.vue?vue&type=template&id=3dbaf74a&scoped=true"
import script from "./ClassicBreadCrumb.vue?vue&type=script&lang=js"
export * from "./ClassicBreadCrumb.vue?vue&type=script&lang=js"

import "./ClassicBreadCrumb.vue?vue&type=style&index=0&id=3dbaf74a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbaf74a"]])

export default __exports__